// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"styles_responsiveContainer__HZUYx"};
module.exports.__checksum = "7879ffdc323b"
